import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import styled from "styled-components";

//images
import ArrowDown from "../assets/images/arrow-down-black.png";

const FAQSs = styled(Row)`
  background-color: #d8127d;
  border-top-width: 4px;
  border-top-style: solid;
  padding: 50px 0 50px 0;
`;

const AccordionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top-style: solid;
  border-top-width: 2px;
  padding: 20px 0 20px 0;
  font-family: "Courier New";
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
`;

const DownArrow = styled.img`
  width: 20px;
  height: 10px;
`;

const FAQAccordion = styled.div`
  padding: 30px 0 0 0;
  border-bottom-style: solid;
  border-bottom-width: 2px;
`;

const FAQSection = () => (
  <FAQSs>
    <Col />
    <Col md={6}>
      <section>
        <h4>FREQUENTLY ASKED QUESTIONS</h4>
        <FAQAccordion>
          <Accordion>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="1">
                <AccordionTitle>
                  <div>What do I bring?</div>
                  <DownArrow src={ArrowDown} alt="Arrow Down" />
                </AccordionTitle>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="1">
                <Card.Body>
                  Please bring confirmation of your ticket order as well as
                  relevant ID. We will be selling tokens for the cider via cash
                  or card, so please bring either of these if you would like to
                  buy tokens. Otherwise a desire to try something new and an
                  interest in the world of cider will work great!
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="2">
                <AccordionTitle>
                  <div>Will you be doing takeaway?</div>
                  <DownArrow src={ArrowDown} alt="Arrow Down" />
                </AccordionTitle>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="2">
                <Card.Body>
                  This year we’ll have an all inclusive cider shop featuring
                  cider from all of our producers. If you fall in love with a
                  particular cidermaker, you can pick up something of theirs to
                  takeaway with you. This will be card only, tokens cannot be
                  exchanged for takeaway cider
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="3">
                <AccordionTitle>
                  <div>Can I buy cider by the pint?</div>
                  <DownArrow src={ArrowDown} alt="Arrow Down" />
                </AccordionTitle>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="3">
                <Card.Body>
                  We will only be giving out a 1/3rd sampling glasses, to help
                  promote trying lots of different ciders, there’s plenty of
                  choice though!
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="4">
                <AccordionTitle>
                  <div>Which cideries are confirmed?</div>
                  <DownArrow src={ArrowDown} alt="Arrow Down" />
                </AccordionTitle>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="4">
                <Card.Body>
                  Keep locked on our social media page @wearehawkes to see the
                  profiles of the Cideries we will be bringing along. The
                  selection is immense with a load of UK firsts!
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="5">
                <AccordionTitle>
                  <div>Can I bring my dog?</div>
                  <DownArrow src={ArrowDown} alt="Arrow Down" />
                </AccordionTitle>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="5">
                <Card.Body>
                  Unfortunately due to the nature of the event, we will not be
                  allowing dogs. With loud music, lighting and lots of people we
                  don’t think this is the best event for a furry friend to
                  attend.
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="6">
                <AccordionTitle>
                  <div>Can I bring an Under 18 year old?</div>
                  <DownArrow src={ArrowDown} alt="Arrow Down" />
                </AccordionTitle>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="6">
                <Card.Body>
                  As this is a Cider focused event with Cidermakers serving the
                  customer directly, we will have a strict No Under 18s policy,
                  with ID checking on the door. We will operate a challenge 25
                  policy, so please be flattered if our door staff ask for you
                  I.D.
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="7">
                <AccordionTitle>
                  <div>Why has the venue changed?</div>
                  <DownArrow src={ArrowDown} alt="Arrow Down" />
                </AccordionTitle>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="7">
                <Card.Body>
                  After an immense first year we are looking to make Ciderama
                  bigger and better, with a focus on bringing in more
                  cidermakers, a wider breadth of styles and an easier layout.
                  We knew we had to stay in our home of South East London, so
                  working with Copeland Park was a natural fit. This new venue
                  is bigger, closer to public transport links and has a much
                  better layout. We know you’ll love it!
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </FAQAccordion>
      </section>
    </Col>
    <Col />
  </FAQSs>
);

export default FAQSection;
